<!--
 * @Autor: Baowang
 * @Date: 2024-11-19 17:03:47
 * @pageName: 登录弹框
 * @LastEditTime: 2024-11-20 16:37:10
-->
<template>
  <div class="login">
    <el-dialog :visible.sync="$store.state.loginFable" :before-close="handleClose" top="0">
      <div class="login_centent animate__animated animate__zoomIn">
        <div class="login_left">
          <div class="login_title">{{ $t('login.login') }}</div>
          <!-- 内容区域 -->
          <div class="acclogin">
            <div class="acclogin_input">
              <el-input v-model="mobile" :placeholder="$t('login.enterPhone')" maxLength="11"></el-input>
            </div>
            <div class="acclogin_input">
              <el-input v-model="captcha" :placeholder="$t('login.enterCode')" maxLength="6">
                <template slot="suffix">
                  <div class="input_count mouseGestures" @click="getCode">{{ downStr }}</div>
                </template>
              </el-input>
            </div>
            <!-- 立即登录 -->
            <el-button class="auuountlogin mouseGestures" round @click="login">{{ $t('login.goLogin') }}</el-button>

            <!-- 协议 -->
            <div class="xieyi_count" @click="clickAgreement">
              <img class="mouseGestures" src="../../assets/images/redio_y.png" alt="" v-if="$store.state.agreementFlag" />
              <img class="mouseGestures" src="../../assets/images/redio.png" alt="" v-else />
              <div>
                <span class="xieyi_count_one">{{ $t('login.agree') }}</span>
                <span class="xieyi_count_one xieyi_count_two mouseGestures" @click="goAgment(1)">
                  {{ $t('login.userAgreement') }}
                </span>
                <span class="xieyi_count_one xieyi_count_two mouseGestures" @click="goAgment(2)">
                  {{ $t('login.privacyPolicy') }}
                </span>
                <span class="xieyi_count_one">{{ $t('login.agreeText') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="login_right">
          <el-image class="login_Img" :src="configInfo.login_bg_image" alt="" fit="cover"></el-image>
          <div class="login_right_info">
            <div class="login_right_info_text">
              {{ configInfo.company_intro }}
            </div>
            <div class="flex align-center justify-between">
              <div class="login_right_info_left">
                <div class="login_right_info_left_content">{{ $t('public.phone') }} {{ configInfo.tel }}</div>
                <div class="login_right_info_left_content">{{ $t('public.address') }} {{ configInfo.company_address }}</div>
              </div>
              <div class="login_right_info_right flex flex-direction align-center justify-center">
                <el-image class="qrcode" :src="configInfo.mp_qrcode" alt="" fit="cover"></el-image>
                <span>{{ $t('login.wxScan') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mobile: "",
      captcha: "",
      password: "",
      isDisabled: false,
      downNum: 60, //倒计时
      downStr: this.$t('login.getCode'),
      configInfo: {}
    };
  },
  mounted() {
    this.getConfigData()
  },
  methods: {
    // 获取配置数据
    getConfigData() {
      this.$api({
        url: "/api/index/get_config",
        method: "post",
        data: {
        }
      }).then((res) => {
        this.configInfo = res.data
      })
    },
    // 登录
    login() {
      if (!this.$store.state.agreementFlag) {
        this.$message.error(this.$t("login.agreementText"));
        return
      }
      if (!this.mobile.length) {
        this.$message.error(this.$t("login.enterPhone"));
        return
      }

      if (!this.captcha) {
        this.$message.error(this.$t("login.enterCode"));
        return
      }

      this.$api({
        url: "/api/user/mobilelogin",
        method: "POST",
        data: {
          mobile: this.mobile,
          captcha: this.captcha,
        }
      }).then((res) => {
        this.$message.success(this.$t("login.loginSuccess"))
        this.$store.commit("updateMe", res.data.userinfo);
        this.handleClose();
      })
    },
    //获取验证码
    async getCode() {
      if (this.isDisabled) {
        return
      }
      let downStr = this.downStr; //验证标题
      if (downStr.indexOf(this.$t("login.second")) != -1) {
        this.$message.error(this.$t("login.await"));
        return;
      }
      if (!this.mobile.length) {
        this.$message.error(this.$t("login.enterPhone"));
        return;
      }

      this.$api({
        url: "/api/sms/send",
        method: "POST",
        data: {
          mobile: this.mobile,
          event: "register"
        }
      }).then((res) => {
        this.$message.success(this.$t("login.sendSuccess"))
        this.sendCodeTime();
      })
    },
    //验证码倒计时
    sendCodeTime() {
      this.isDisabled = true; //将按钮置为不可点击
      this.downStr = this.downNum + this.$t("login.second");
      let nums = parseInt(this.downNum);
      let that = this;
      let clock = setInterval(function () {
        nums--;
        if (nums > 0) {
          that.downStr = nums + this.$t("login.second");
        } else {
          clearInterval(clock); //清除js定时器
          that.isDisabled = false;
          that.downStr = this.$t("login.getCode");
          that.downNum = 60; //重置时间
        }
        this.downKey += 1;
      }, 1000);
    },
    // 点击协议
    clickAgreement() {
      this.$store.commit("updateAgreementFlag")
    },
    // 关闭弹框
    handleClose() {
      this.$store.commit("updataLogin", false);
    },
    // 跳转协议
    goAgment(type) {
      this.handleClose();
      this.$router.push({ name: "/personalCenter/agreement", query: { type: type } });
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;

  /deep/ .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    width: 1200px;
    height: 675px;
  }

  /deep/ .el-dialog__header {
    padding: 0;
  }

  /deep/ .el-dialog__headerbtn {
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 50%;
    padding: 3px;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  /deep/ .el-dialog__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-dialog__close {
    font-size: 30px;
  }

  .login_centent {
    width: 100%;
    display: flex;
    align-items: center;

    .login_left {
      width: 600px;
      padding: 0 45px;
      box-sizing: border-box;

      .login_title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 40px;
        color: #333333;
        text-align: center;
      }

      // 账号登录
      .acclogin {
        width: 100%;
        margin-top: 40px;

        .acclogin_input {
          width: 100%;
          margin-bottom: 10px;
          box-sizing: border-box;
          border: 1px solid #E5E6EB;
          border-radius: 8px;
          overflow: hidden;

          .el-input {
            height: 64px;
            background: #E5E6EB;


            /deep/ .el-input__inner {
              height: 64px;
              line-height: 64px;
              border-radius: 8px;
              font-size: 18px;
            }

            /deep/ .el-input__suffix {
              right: 0;
            }
          }

          .input_count {
            min-width: 120px;
            height: 64px;
            line-height: 64px;
            text-align: center;
            background: #E70012;
            font-weight: normal;
            font-size: 16px;
            color: #ffffff;
          }
        }

        .xieyi_count {
          width: 100%;
          box-sizing: border-box;
          padding: 20px 0 0;
          display: flex;

          img {
            width: 25px;
            height: 25px;
            margin-right: 5px;
          }

          .xieyi_count_one {
            font-family: PingFang SC, PingFang SC;
            font-weight: normal;
            font-size: 14px;
            color: #67686c;
          }

          .xieyi_count_two {
            color: #E70012;
          }
        }

        // 立即登录
        .auuountlogin {
          width: 100%;
          height: 68px;
          border-radius: 8px;
          background-color: #E70012;
          font-family: PingFang SC, PingFang SC;
          font-weight: normal;
          font-size: 18px;
          color: #ffffff;
          margin-top: 60px;
        }
      }
    }


    .login_right {
      width: 600px;
      height: 675px;
      position: relative;

      .login_Img {
        width: 600px;
        height: 675px;
        position: absolute;
        z-index: 0;
      }

      .login_right_info {
        width: 600px;
        min-height: 200px;
        position: absolute;
        background: rgba(0, 0, 0, 0.4);
        bottom: 0;
        padding: 40px 60px 20px;
        color: white;
        box-sizing: border-box;


        .login_right_info_text {
          font-weight: bold;
          font-size: 22px;
          padding-bottom: 10px;
        }

        .login_right_info_left_content {
          font-size: 16px;
          padding-top: 10px;
        }

        .login_right_info_right {
          font-size: 14px;

          .qrcode {
            width: 80px;
            height: 80px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
